<template>
    <div class="template template--sidebar">
        <sidebar :user="user" >
          <p class="sidebar__empty small" >
            Dit is jouw persoonlijke werkmap, hier komen al jouw gemaakte opdrachten in te staan.
          </p>
        </sidebar>

        <div class="page-wrap">
          <div class="page-view">
            <header class="page-header page-header--wide">
                <h1>Hallo {{ user.firstname }}</h1>
                <p>Welkom bij Kiempunt! De komende tijd krijg je hier verschillende opdrachten voor het vak beeldende vorming te zien. Maar voor het zover is vul je eerst je klascode in, zodat je samen met je klasgenootjes de opdrachten kunt maken.</p>
              <hr>
            </header>

            <div class="page-content">
              <h1 class="banner"><span>Aanmelden bij jouw klas</span></h1>
              <group :user="user"></group>
            </div>
            
            <hr class="flipped">

          </div>
        </div>
    </div>
</template>


<script>

import notify from 'js/components/notifications/notificationsMixin'

import Sidebar from 'js/admin/components/sidebar/Sidebar.vue'
import PrimaryButton from 'js/components/elements/PrimaryButton.vue'
import Loading from 'js/components/elements/Loading.vue'
import Group from 'js/components/settings/Group.vue'

export default {
    name: 'Lobby',
    mixins: [ notify ],
    components: { PrimaryButton, Loading, Sidebar, Group },

    data: function() {
        return {
            loading: false,
        }
    },

    vuex: {
        getters: {
        },
        actions: {
        }
    },

    computed: {
        user: function() {
            return this.$store.state.users.current
        },
    },

    methods: {


    },

    created: function() {


    }
}
</script>


<style lang="scss">

    @import 'global';

    .page-header--inverted {
        color: $color-typography-inverted;
    }

</style>



// WEBPACK FOOTER //
// Lobby.vue?3adefae9